// extracted by mini-css-extract-plugin
export var link = "_qa-0";